import { GET_NOTIFICATIONS_URL } from '../constants/notifications'
import type { GetNotificationsResponse } from '../types/notifications'

export const getNotificationsService = async ({
	token,
	accountId,
}: {
	token: string | null
	accountId: string | null
}): Promise<GetNotificationsResponse | null> => {
	let response

	if (token && accountId) {
		const url = GET_NOTIFICATIONS_URL.replace('{accountid}', accountId)
		response = await fetch(url, {
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`,
			},
			next: { revalidate: 0 },
		})

		if (response.ok) {
			return response.json()
		}
	}

	console.error(
		`[Customer Notifications Service - Get Notifications] failed to fetch.\n ${response?.status}: ${response?.statusText}`
	)

	return null
}
